import { render } from "./quillComp.vue?vue&type=template&id=b531973c&ts=true"
import script from "./quillComp.vue?vue&type=script&lang=ts"
export * from "./quillComp.vue?vue&type=script&lang=ts"

import "./quillComp.vue?vue&type=style&index=0&id=b531973c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__